import React from 'react';
import { LcaResultModel } from 'types/types';

type LcaGridErrors = Record<string, Record<keyof LcaResultModel, string>> | null;

const LcaGridErrorsContext = React.createContext<LcaGridErrors>(null);
export default LcaGridErrorsContext;
